import { Icon } from 'antd';
import { IconProps } from 'antd/lib/icon';
import * as React from "react";

const IconFont = Icon.createFromIconfontCN({
	scriptUrl: '/js/iconfont.js'
});

interface Props extends IconProps {
}

export const ZuluIcon: React.SFC<Props> = (props) => {
	if (props.type == null) {
		return null;
	}
	if (props.type.search("^icon-") !== -1) {
		return <IconFont {...props} className="icon fa" />;
	}
	return <Icon {...props} className="icon" />;
}



// WEBPACK FOOTER //
// ./src/app/shared/icon.tsx